<template>
<!-- updated -->
  <!--大loading，通常用于页面加载-->
  <transition name="fade">
    <div class="loading-v1">
      <div class="miniLoading">
        <!-- <div class="mum">
          <em></em>
          <div class="son"></div>
        </div>
        <h1>加载中...</h1> -->
        <img v-if="ENTRANCE === '深大' || ENTRANCE === '建行'"
          src="../../assets/images/theme/shenda/loading.gif"
          class="loading-img"
          alt="">
        <img v-else-if="ENTRANCE === '南航' || ENTRANCE === '中广核、华大'"
          src="../../assets/images/theme/baojiankang/loading.gif"
          class="loading-img"
          alt="">
        <img v-else
          src="../../assets/images/loading.gif"
          class="loading-img"
          alt="">
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loading',
  data () {
    return {
      spokeArr: new Array(12),
      ENTRANCE
    }
  }
}
</script>

<style lang="less" scoped>
@image: "../../assets/images/";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.loading-v1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
}

.miniLoading {
  width: 1rem;
  height: 1rem;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -0.5rem 0 0 -0.5rem;
  border-radius: 0.1rem;
  z-index: 40;

  h1 {
    font-size: 28/200rem;
    line-height: 28/200rem;
    color: #999;
    text-align: center;
    font-weight: normal;
  }

  .mum {
    position: relative;
    width: 106/200rem;
    height: 106/200rem;
    background: url("@{image}mun2.png") no-repeat;
    background-size: 106/200rem 106/200rem;
    margin: 0.14rem auto 0.02rem auto;
  }

  .son {
    width: 36/200rem;
    height: 36/200rem;
    position: absolute;
    left: 0.27rem;
    top: 0.2rem;
    background: url("@{image}son2.png") no-repeat 0 0;
    background-size: 36/200rem 36/200rem;
    animation: rotate 500ms ease-in infinite;
  }

  em {
    width: 3/100rem;
    height: 3/100rem;
    border-radius: 3px;
    background-color: #f7f7f7;
    position: absolute;
    top: 0.13rem;
    left: 0.3rem;
    animation: zhayan 1000ms linear infinite;
  }

  .loading-img {
    width: 0.7rem;
  }
}

// toast弹窗
.toast {
  position: fixed;
  width: 100%;
  top: -1rem/200;
  bottom: -1rem/200;
  background-color: transparent;
  z-index: 100;

  .loading-container {
    background-color: rgba(102, 102, 102, 0.9);
    width: 250/200rem;
    min-height: 250/200rem;
    position: fixed;
    top: 50%;
    // margin-top: -250/200rem;
    left: 50%;
    transform: translate(-50%, -50%);
    // margin-left: -250/400rem;
    border-radius: 20/200rem;

    .toast-title {
      font-size: 30/200rem;
      color: #fff;
      padding-top: 40/200rem;
      text-align: center;
      width: 200rem/200;
      line-height: 50/200rem;
      margin: 0 auto;
      padding-bottom: 20/200rem;
    }

    .toast-loader {
      margin: 0 auto;
      height: 125/200rem;
      position: relative;
    }

    .spoke {
      position: absolute;
      top: 100%;
      margin-top: -15/200rem;
      left: 50%;
      margin-left: -15/200rem;
      transform-origin: 50% -100%;
      background: #fff;
      width: 5/200rem;
      height: 15/200rem;
      animation: spoke 1.2s infinite;
      border-radius: 5/200rem;
    }

    .spoke:nth-of-type(0n + 1) {
      transform: translateX(100%) rotate(-90deg);
      animation-delay: 0.3s;
    }

    .spoke:nth-of-type(0n + 2) {
      transform: translateX(100%) rotate(-60deg);
      animation-delay: 0.4s;
    }

    .spoke:nth-of-type(0n + 3) {
      transform: translateX(100%) rotate(-30deg);
      animation-delay: 0.5s;
    }

    .spoke:nth-of-type(0n + 4) {
      transform: translateX(100%) rotate(0deg);
      animation-delay: 0.6s;
    }

    .spoke:nth-of-type(0n + 5) {
      transform: translateX(100%) rotate(30deg);
      animation-delay: 0.7s;
    }

    .spoke:nth-of-type(0n + 6) {
      transform: translateX(100%) rotate(60deg);
      animation-delay: 0.8s;
    }

    .spoke:nth-of-type(0n + 7) {
      transform: translateX(100%) rotate(90deg);
      animation-delay: 0.9s;
    }

    .spoke:nth-of-type(0n + 8) {
      transform: translateX(100%) rotate(120deg);
      animation-delay: 1s;
    }

    .spoke:nth-of-type(0n + 9) {
      transform: translateX(100%) rotate(150deg);
      animation-delay: 1.1s;
    }

    .spoke:nth-of-type(0n + 10) {
      transform: translateX(100%) rotate(180deg);
      animation-delay: 0s;
    }

    .spoke:nth-of-type(0n + 11) {
      transform: translateX(100%) rotate(210deg);
      animation-delay: 0.1s;
    }

    .spoke:nth-of-type(0n + 12) {
      transform: translateX(100%) rotate(240deg);
      animation-delay: 0.2s;
    }

    // success图标
    .success {
      width: 125rem/200;
      min-height: 125rem/200;
      margin: 0 auto;

      .success-pic {
        width: 125rem/200;
        height: 125rem/200;
        background-image: url("@{image}success.png");
        background-position: center 10rem/200;
        background-repeat: no-repeat;
        background-size: 150rem/200 150rem/200;
      }
    }

    // fail图标
    .fail {
      width: 125rem/200;
      min-height: 125rem/200;
      margin: 0 auto;
      position: relative;

      .before {
        position: absolute;
        left: 50%;
        top: 40rem/200;
        background-color: #fff;
        height: 100rem/200;
        width: 12rem/200;
        border-radius: 12rem/200;
        transform: rotate(45deg);
        margin-left: -12rem/400;
      }

      .after {
        position: absolute;
        left: 50%;
        top: 40rem/200;
        background-color: #fff;
        height: 100rem/200;
        width: 12rem/200;
        border-radius: 12rem/200;
        transform: rotate(-45deg);
        margin-left: -12rem/400;
      }
    }
  }
}

@keyframes spoke {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

@keyframes rotate {
  0% {
    top: 0.2rem;
    transform: rotate(0deg);
  }
  25% {
    top: 0.25rem;
    transform: rotate(-10deg);
  }
  50% {
    top: 0.2rem;
    transform: rotate(0deg);
  }
  75% {
    top: 0.25rem;
    transform: rotate(10deg);
  }
  100% {
    top: 0.2rem;
    transform: rotate(0deg);
  }
}

@keyframes zhayan {
  0% {
    height: 0.03rem;
    top: 0.13rem;
  }
  10% {
    height: 0.01rem;
    top: 0.14rem;
  }
  20% {
    height: 0.03rem;
    top: 0.13rem;
  }
  30% {
    height: 0.01rem;
    top: 0.14rem;
  }
  40% {
    height: 0.03rem;
    top: 0.13rem;
  }
  100% {
    height: 0.03rem;
    top: 0.13rem;
  }
}
</style>
